<template>
    <div class="px-2 w-auto">
        <i class="fas fa-check-square text-blue-500cursor-pointer" v-if="selected" @click.prevent="$emit('clicked', item)"></i>
        <i class="far fa-square cursor-pointer" v-else @click.prevent="$emit('clicked', item)"></i>
    </div>
</template>

<script>
    export default {
        props: {
            selected: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object
            }
        }
    }
</script>